'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid from "./dev.cheleb.scalamigen.-Validation-Status$-Invalid.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction from "./scala.runtime.-Abstract-Partial-Function.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$package$$anon$15(f$3) {
  this.HI = null;
  this.HI = f$3;
}
export { $c_Ldev_cheleb_scalamigen_Form$package$$anon$15 as $c_Ldev_cheleb_scalamigen_Form$package$$anon$15 };
$p = $c_Ldev_cheleb_scalamigen_Form$package$$anon$15.prototype = new $j_scala$002eruntime$002e$002dAbstract$002dPartial$002dFunction.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$package$$anon$15;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$package$$anon$15() {
}
export { $h_Ldev_cheleb_scalamigen_Form$package$$anon$15 as $h_Ldev_cheleb_scalamigen_Form$package$$anon$15 };
$h_Ldev_cheleb_scalamigen_Form$package$$anon$15.prototype = $p;
$p.gz = (function(x) {
  if ((x !== null)) {
    var x120 = x.ad;
    if ((x120 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
      if (x120.g5) {
        return true;
      }
    }
  }
  return false;
});
$p.gt = (function(x, default$1) {
  if ((x !== null)) {
    var x127 = x.ad;
    var field = x.ac;
    if ((x127 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
      var x130 = x127.hB;
      if (x127.g5) {
        return this.HI.bB(field, x130);
      }
    }
  }
  return default$1.j(x);
});
$p.de = (function(x) {
  return this.gz(x);
});
$p.cr = (function(x, default$1) {
  return this.gt(x, default$1);
});
var $d_Ldev_cheleb_scalamigen_Form$package$$anon$15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$package$$anon$15, "dev.cheleb.scalamigen.Form$package$$anon$15", ({
  ja: 1,
  aO: 1,
  o: 1,
  t: 1,
  a: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$package$$anon$15 as $d_Ldev_cheleb_scalamigen_Form$package$$anon$15 };
